/**
 * Created by comoon on 3/2/16.
 */

var React = require('react');

var $ = require("jquery");

var _ = require("underscore");

var ALikeStore = require("../store/ALikeStore");

var Dispatcher = require("../Dispatcher");

var {ActionConstants, ElementConstants, EventConstants} = require("../Constants");

var {format} = require("../util/price");

var TripType = require("../conf/trip-type");

var TripGrade = require("../conf/trip-grade");

var productUtils = require('../util/productUtils');

var {
    ProductTips,
    ProductDescribe,
    ProductDescribeDetail,
    AirTicketDescribe,
    HotelDescribeDetail,
    HotelDescribeDetailA
} = require('./ProductDescribe');

module.exports = React.createClass({

    displayName: "ProductList",

    getInitialState(){
        return {
            productInfo: null,
            hotelStandardOpen: false,
            planeStandardOpen: false,
            gradeType: ALikeStore.get_gradeType()
        };
    },
    componentWillMount(){
        ALikeStore.on(EventConstants.AJAX_LOAD_PRODUCT_LIST_COMPLETE, this.on_productInfoChange);
        ALikeStore.on(EventConstants.ACTION_SWITCH_GRADE_TYPE, this.on_switchGradeComplete);
    },
    componentWillUnmount(){
        ALikeStore.off(EventConstants.AJAX_LOAD_PRODUCT_LIST_COMPLETE, this.on_productInfoChange);
        ALikeStore.off(EventConstants.ACTION_SWITCH_GRADE_TYPE, this.on_switchGradeComplete);
    },
    on_productInfoChange(){

        var productInfo = ALikeStore.get_currentProductList(!this.props.absent);
        this.tips = ALikeStore.get_productTips();

        if(!productInfo){
            this.setState({productInfo});
            return
        }

        var hasService = true;//默认包含服务包
        var versionId = ALikeStore.get_currentVersion();
        if (versionId) {
            var version = ALikeStore.get_versionDetail(ALikeStore.get_currentVersion());
            hasService = version.hasService;
        }

        this.setState({productInfo, hasService});
    },
    on_switchGradeComplete(){
        this.setState({
            gradeType: ALikeStore.get_gradeType()
        })
    },
    handle_moveToUncontains(){
        $(window).scrollTop(($("#priceUncontain").offset().top - $(ElementConstants.TOP_NAV_CLASS).height()));
    },
    handle_toggleHotelStandard(){
        var hotelStandardOpen = this.state.hotelStandardOpen;

        this.setState({hotelStandardOpen: !hotelStandardOpen});
    },
    handle_togglePlaneStandard(){
        var planeStandardOpen = this.state.planeStandardOpen;

        this.setState({planeStandardOpen: !planeStandardOpen});
    },
    handle_toggleTripGrade(gradeType){

        var tripInfo = ALikeStore.get_tripBasicInfo();
        var versionId = gradeType === TripGrade.Enjoy.code ? tripInfo.versionId : tripInfo.luxuryVersionId ;
        var data = {
            versionId: versionId,
            gradeType: gradeType
        };
        Dispatcher.dispatch({type: ActionConstants.SWITCH_GRADE_TYPE, data: data});
    },
    /**
     * 商品是否显示数量
     */
    hasNum(){

        var tripInfo = ALikeStore.get_tripBasicInfo();

        var isTripB = (tripInfo.tripType === TripType.WalleB.code) ? true: false;

        var isDefaultProductInfo = ALikeStore.is_defaultProductInfo();

        return !isDefaultProductInfo || isTripB;
    },
    render(){

        if (!this.state.productInfo) {

            return null;
        }

        var props = this.props;
        var absent = props.absent;
        var trip = ALikeStore.get_tripBasicInfo();

        this.tips = ALikeStore.get_productTips();

        //准AA or 准AB
        var isTripA = (trip.tripType === TripType.WalleA.code) ? true: false;

        var isDefaultProductInfo = ALikeStore.is_defaultProductInfo();

        return (
            <div className="price-profile feature-profile" id={`price${absent ? 'Uncontain' : 'Contain'}`}>
                { absent ?
                    this.render_outPriceTitle() :
                    this.render_inPriceTitle()
                }
                <div className="mod-product-table content">
                    {
                        !absent && isTripA  ? (
                            isDefaultProductInfo ? (
                                this.render_defaultGrade()
                            ) : (
                                this.render_currentGrade()
                            )
                        ):null

                    }
                    <table className="product-table">
                        <tbody>
                        {this.render_airTicketItem()}
                        {this.render_hotelItem()}
                        {this.render_tourItem()}
                        {this.render_eurailItem()}
                        {this.render_carRentItem()}
                        {this.render_pickupItem()}
                        {this.render_visaItem()}
                        {this.render_insuranceItem()}
                        {this.render_wifiItem()}
                        {this.render_otherItem()}
                        {this.render_service()}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    },
    render_inPriceTitle(){
        var isAbsent = ALikeStore.isAbsent();
        return (
            <div className="title">
                <span className="main">价格包含</span>
                {
                    isAbsent ? (<span onClick={this.handle_moveToUncontains} className="vice c-link"
                                        style={{cursor: 'pointer'}}>查看价格未包含内容 <i className="icon-m-indicator-more"></i> </span>) : null
                }
            </div>
        );
    },
    render_outPriceTitle(){

        return (
            <div className="title" id="priceUncontain">
                <span className="main">价格未包含</span>
            </div>
        );
    },
    /**
     * 默认行程,tab切换
     */
    render_defaultGrade(){
        var tripInfo = ALikeStore.get_tripBasicInfo();
        var price = format(tripInfo.price);
        var luxuryPrice = format(tripInfo.luxuryPrice);
        var gradeType = ALikeStore.get_gradeType();
        return(
            <ul className="cell-tabs">
                <li className={(+gradeType === 0) ? "f-tab-t c-tab current" : "f-tab-t c-tab"} onClick={(e)=> this.handle_toggleTripGrade(0)}>
                    <h3 className="title">
                        <i className={(+gradeType === 0) ? "icon-m-indicator-radio-checked" : "icon-m-indicator-radio"}></i>
                        <span className="main">{TripGrade.Enjoy.name}</span>
                        <span className="price ng-scope">
                            {
                                +tripInfo.price ? (
                                    <span>参考价<em>{price}</em>元/人</span>
                                ):(
                                    <span>需询价</span>
                                )
                            }
                        </span>
                    </h3>
                </li>
                <li className={(+gradeType === 1) ? "f-tab-t c-tab current" : "f-tab-t c-tab"} onClick={(e)=> this.handle_toggleTripGrade(1)}>
                    <h3 className="title">
                        <i className={(+gradeType === 1) ? "icon-m-indicator-radio-checked" : "icon-m-indicator-radio"}></i>
                        <span className="main">{TripGrade.Luxury.name}</span>
                        <span className="price ng-scope">
                            {
                                +tripInfo.luxuryPrice ? (
                                    <span>参考价<em>{luxuryPrice}</em>元/人</span>
                                ):(
                                    <span>需询价</span>
                                )
                            }
                        </span>
                    </h3>
                </li>
            </ul>
        )
    },
    /**
     * 当前的类型,品质,优选
     */
    render_currentGrade(){
        var grade = ALikeStore.get_gradeType();
        var gradeName = grade>=0 ? _.findWhere(TripGrade, {code: grade}).name : null;
        if(!gradeName){
            return;
        }
        return(
            <div className="grade-type">
                <h3 className="title">
                    <i className="icon-m-indicator-radio-gray-checked"></i>
                    <span className="main">{gradeName}</span>
                </h3>
            </div>
        )
    },
    render_airTicketItem(){

        var absent = this.props.absent;

        var planeStandardOpen = this.state.planeStandardOpen;

        var planes = this.state.productInfo.plane;

        if (!planes) {

            return null;
        }


        return (
            <tr className="">
                <td className="type">
                    <i className="icon-super-detail-p1"/>
                    <h4>机票</h4>
                </td>
                <td className="content js-select-product">
                    <AirTicketDescribe data={planes} hasNum={ this.hasNum() } />
                    {
                        !absent ? (
                            <div>
                                <div className="port-desc info">* 口岸城市：北京、上海、广州、香港、成都、杭州等， 详见产品须知</div>
                                <dl className={`cell-like-dropdown reg-like-dropdown-detail ${planeStandardOpen ? 'open' : ''}`}
                                    onClick={this.handle_togglePlaneStandard}>
                                    <dt className={planeStandardOpen ? 'open': ''}>
                                        选航班，我们有三享！
                                        <i className="fcon-arrow-l fcon-arrow-l-orange"/>
                                    </dt>
                                    {planeStandardOpen ? (
                                        <dd>
                                            <p className="title">
                                                <i className="icon-super-detail-dot"/>
                                                <span className="p-pl5">注重安全，享安心</span>
                                            </p>
                                            <ul>
                                                <li>不选低评级航空，</li>
                                                <li>旅行玩耍好心情，怎能为航空安全担惊受怕？</li>
                                            </ul>
                                        </dd>
                                    ) : null}
                                    {planeStandardOpen ? (
                                        <dd>
                                            <p className="title">
                                                <i className="icon-super-detail-dot"/>
                                                <span className="p-pl5">追求优质，享舒心</span>
                                            </p>
                                            <ul>
                                                <li>长途旅行飞那么久，当然得舒适！</li>
                                                <li>国际段航班不使用廉价航空，懂你对品质的要求。</li>
                                            </ul>
                                        </dd>
                                    ) : null}
                                    {planeStandardOpen ? (
                                        <dd>
                                            <p className="title">
                                                <i className="icon-super-detail-dot"/>
                                                <span className="p-pl5">远离折腾，享省心</span>
                                            </p>
                                            <ul>
                                                <li>我们选用的国际段航班，转机次数≤1次，</li>
                                                <li>严格控制转机时长，不浪费宝贵的旅行时间。</li>
                                            </ul>
                                        </dd>
                                    ) : null}
                                </dl>
                            </div>
                        ) : null
                    }

                </td>
            </tr>
        );
    },
    render_hotelItem(){

        var self = this;

        var absent = self.props.absent;

        var state = self.state;

        var hotels = productUtils.sortByDays( this.state.productInfo.hotel );

        var currentGradeType = ALikeStore.get_gradeType();

        if (!hotels || (hotels.length === 0)) {

            return null;
        }

        var trip = ALikeStore.get_tripBasicInfo();
        //准AA or 准AB
        var isTripA = (trip.tripType === TripType.WalleA.code) ? true: false;

        // 行程级别
        var quote = ALikeStore.get_recordDetail(ALikeStore.get_currentRecord());
        var grade,gradeName;

        if( quote) {
            grade = quote.grade;
            gradeName = grade>=0 ? _.findWhere(TripGrade, {code: grade}).prefix : null;
        }else{
            gradeName = TripGrade.list[ currentGradeType ].prefix;
        }


        return (
            <tr className="">
                <td className="type">
                    <i className="icon-super-detail-p2"/>
                    <h4>酒店</h4>
                </td>
                <td className="content js-select-product">
                    <h5>全程精选{ gradeName }酒店：</h5>
                    <div className="product-list" style={{display: 'block'}}>
                        <div className="days">
                            {
                                !isTripA
                                    ? <HotelDescribeDetailA data={hotels} productType={ 'hotel' } hasFullName={true} hasNum={ this.hasNum() }/>
                                    : <HotelDescribeDetail data={hotels} hasNum={ this.hasNum() } />
                            }
                        </div>
                    </div>
                    {
                        !absent ? (
                            <div>
                                <p className="info" style={{color: '#aaa'}}>
                                    *&nbsp;考虑到行程安排、酒店房型库存等原因，实际预定时可能会选用其他同级别酒店</p>
                                <dl className={`cell-like-dropdown reg-like-dropdown-detail ${state.hotelStandardOpen ? 'open' : ''}`}
                                    onClick={self.handle_toggleHotelStandard}>
                                    <dt className={state.hotelStandardOpen ? 'open' : ''}>
                                        挑酒店，我们有三不！
                                        <i className="fcon-arrow-l fcon-arrow-l-orange"/>
                                    </dt>
                                    {state.hotelStandardOpen ? (
                                        <dd>
                                            <p className="title">
                                                <i className="icon-super-detail-dot"/>
                                                <span className="p-pl5">不只看星级</span>
                                            </p>
                                            <ul>
                                                <li>是否安全、便利、是否对华人友好……都是我们考虑的因素。</li>
                                                <li>结合百万真实用户评价，严格评分、筛选。</li>
                                                <li>平均100家酒店只能选出3.7家。</li>
                                            </ul>
                                        </dd>
                                    ) : null}
                                    {state.hotelStandardOpen ? (
                                        <dd >
                                            <p className="title">
                                                <i className="icon-super-detail-dot"/>
                                                <span className="p-pl5">不是黄金位置的不选</span>
                                            </p>
                                            <ul>
                                                <li>自驾和包车行程精选贴合线路设计、行车及停车便利的高品质酒店。</li>
                                                <li>其他行程选择黄金地段的的精品酒店，临近交通枢纽或景点，住得惬意、步行轻松抵达。</li>
                                            </ul>
                                        </dd>
                                    ) : null}
                                    {state.hotelStandardOpen ? (
                                        <dd >
                                            <p className="title">
                                                <i className="icon-super-detail-dot"/>
                                                <span className="p-pl5">不选贵的，选性价比好的</span>
                                            </p>
                                            <ul>
                                                <li>经过行程大师全球旅行达人亲身实地体验。</li>
                                                <li>从同星级酒店中，为你精选性价比更好的。</li>
                                            </ul>
                                        </dd>
                                    ) : null}
                                </dl>
                            </div>
                        ): null
                    }

                </td>
            </tr>
        );
    },
    render_tourItem(){

        var tours = this.state.productInfo.tour;

        if (!tours) {

            return null;
        }

        return (
            <tr className="">
                <td className="type">
                    <i className="icon-super-detail-p3"/>
                    <h4>观光</h4>
                </td>
                <td className="content js-select-product">
                    <ProductDescribeDetail data={tours} productType={ 'tour' }  hasNum={ this.hasNum() } />
                </td>
            </tr>
        );
    },
    render_carRentItem(){

        var cars = this.state.productInfo.car;

        if (!cars) {

            return null;
        }

        return (
            <tr className="">
                <td className="type">
                    <i className="icon-super-detail-p4"/>
                    <h4>车辆</h4>
                </td>
                <td className="content js-select-product">
                    <ProductDescribeDetail data={cars} productType={ 'car' }  hasNum={ this.hasNum() } />
                </td>
            </tr>
        );
    },
    render_eurailItem(){
        var trains = this.state.productInfo.train;

        if (!trains || trains.length === 0) {

            return null;
        }

        return (
            <tr className="">
                <td className="type">
                    <i className="icon-super-detail-p4"/>
                    <h4>交通</h4>
                </td>
                <td className="content js-select-product">
                    <ProductDescribeDetail
                        data={trains}
                        productType={ 'train' } hasNum={ this.hasNum() } />
                </td>
            </tr>
        );
    },
    render_pickupItem(){

        var pickups = this.state.productInfo.pickup;

        if (!pickups) {

            return null;
        }

        return (
            <tr className="">
                <td className="type">
                    <i className="icon-super-detail-p4"/>
                    <h4>车辆</h4>
                </td>
                <td className="content js-select-product">
                    <ProductDescribe data={pickups} productType={ 'pickup' }  hasNum={ this.hasNum() } />
                </td>
            </tr>
        );
    },
    render_wifiItem(){

        var wifis = this.state.productInfo.wifi;

        if (!wifis) {

            return null;
        }

        return (
            <tr className="">
                <td className="type">
                    <i className="icon-super-detail-p7"/>
                    <h4>设备</h4>
                </td>
                <td className="content js-select-product">
                    <ProductDescribe data={wifis} productType={ 'wifi' }  hasNum={ this.hasNum() } />
                </td>
            </tr>
        );
    },
    render_insuranceItem(){

        var insurances = this.state.productInfo.insurance;

        if (!insurances) {

            return null;
        }
        return (
            <tr className="">
                <td className="type">
                    <i className="icon-super-detail-p6"/>
                    <h4>保险</h4>
                </td>
                <td className="content js-select-product">
                    <ProductDescribe data={insurances} productType={ 'insurance' } hasNum={ this.hasNum() } />
                </td>
            </tr>
        );
    },
    render_visaItem(){

        var visas = this.state.productInfo.visa;

        if (!visas) {

            return null;
        }
        return (
            <tr className="">
                <td className="type">
                    <i className="icon-super-detail-p5"/>
                    <h4>签证</h4>
                </td>
                <td className="content js-select-product">
                    <ProductDescribe data={visas} productType={ 'visa' }  hasNum={ this.hasNum() } />
                </td>
            </tr>
        );
    },
    render_otherItem(){

        var others = this.state.productInfo.other;

        if (!others) {

            return null;
        }

        return (
            <tr className="">
                <td className="type">
                    <i className="icon-m-product-other"/>
                    <h4>其他</h4>
                </td>
                <td className="content js-select-product">
                    <ul className="item-list">
                        <ProductDescribe data={others} />
                    </ul>
                </td>
            </tr>
        );
    },
    render_service(){

        var item = (this.state.hasService && !this.props.absent)  || (!this.state.hasService && this.props.absent) ? (
            <tr className="">
                <td className="type">
                    <i className="icon-super-detail-p8"/>
                    <h4>服务</h4>
                </td>
                <td className="">
                    <div className="service-wrapper" ref="serviceWrapper">
                        <ul className="mod-advantage-big tl-advantage-list">
                            <li>
                                <a href="/on/benefit/?tab=2&rf=liyidianrukoujqzl_ah5down" data-tag="zhilu">
                                    <i className="icon icon-super-detail-ip-1"></i>
                                    <i className="fcon-arrow-r"></i>
                                    <p className="title">指路精确到米</p>
                                    <p>
                                        告诉你地铁怎么换，步行多少米……更把全程近200段线路导航，都帮你提前设定好。
                                    </p>
                                    <p>
                                        1秒轻松导航，国外不迷路!
                                    </p>
                                </a>
                            </li>
                            <li>
                                <a href="/on/benefit/?tab=1&rf=rf=liyidianrukousjdy_ah5down" data-tag="shouji">
                                    <i className="icon icon-super-detail-ip-2"></i>
                                    <i className="fcon-arrow-r"></i>
                                    <p className="title">手机智能导游</p>
                                    <p>
                                        每天去哪里，怎么玩……都详细说明；到景点，有中文语音为你讲解。
                                    </p>
                                    <p>外语不好没关系，手机导游带你玩！</p>
                                </a>
                            </li>
                            <li>
                                <a href="/on/benefit/?tab=3&rf=liyidianrukoudzxc_ah5down" data-tag="dingzhi">
                                    <i className="icon icon-super-detail-ip-3"></i>
                                    <i className="fcon-arrow-r"></i>
                                    <p className="title">达人定制行程</p>
                                    <p>
                                        “在梵蒂冈居然不用排大队，行程安排的真好。”惊喜的定制体验，数十万用户正在感受。
                                    </p>
                                    <p>专业定制，超越你的期待。</p>
                                </a>
                            </li>
                            <li>
                                <a href="/on/benefit/?tab=4&rf=liyidianrukoukhsc_zhunah5down" data-tag="shouce">
                                    <i className="icon icon-super-detail-ip-4"></i>
                                    <i className="fcon-arrow-r"></i>
                                    <p className="title">定制客户手册</p>
                                    <p>
                                        把酒店确认单、机票、门票等*所有纸质凭证，按日期手工排序，还精心标注好。
                                    </p>
                                    <p>出行用的各种票据，都帮你整理好。</p>
                                    <p>*以用户实际预定的旅行产品为准</p>
                                </a>
                            </li>
                            <li>
                                <a href="/on/benefit/?tab=5&rf=liyidianrukoujjfw_ah5down" data-tag="fuwu">
                                    <i className="icon icon-super-detail-ip-5"></i>
                                    <i className="fcon-arrow-r"></i>
                                    <p className="title">7X24小时紧急服务</p>
                                    <p>
                                        行程大师全球旅行服务中心，拥有庞大的紧急服务团队。随时守候，全力帮你解决困难。
                                    </p>
                                    <p>遇事儿有人管，自由行更放心！</p>
                                </a>
                            </li>
                            <li>
                                <a href="/on/benefit/?tab=6&rf=liyidianrukoubzjjj_ah5down" data-tag="quanbao">
                                    <i className="icon icon-super-detail-ip-6"></i>
                                    <i className="fcon-arrow-r"></i>
                                    <p className="title">不止机酒 一站全搞定</p>
                                    <p>
                                        行程中需要提前预定的机票、酒店、签证、租车、包车、火车票、演出、观光等。
                                    </p>
                                    <p>*精心优选，为你轻松搞定</p>
                                    <p>*以用户实际预定的旅行产品为准</p>
                                </a>
                            </li>
                        </ul>
                    </div>
                </td>
            </tr>
        ): null;

        return item;
    }
});
 


/** WEBPACK FOOTER **
 ** ./script/detail-m/ProductList.jsx
 **/